export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8026.8207ca56.jpg";